export default __webpack_public_path__ + "static/media/bn.f964b073.svg";